import { render, staticRenderFns } from "./DeletedTopics.vue?vue&type=template&id=c47547e0&"
import script from "./DeletedTopics.vue?vue&type=script&lang=js&"
export * from "./DeletedTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports